import { paginationSchema } from './pagination'
import { z } from 'zod'

export const monitorUsageByUserSchema = z
  .object({
    id: z.string(),
    user: z.string(),
    credits: z.number(),
  })
  .describe('Monitor Usage By User')

export type MonitorUsageByUserDetails = z.infer<typeof monitorUsageByUserSchema>

export const monitorUsageByUserListSchema = z
  .object({
    pagination: paginationSchema,
    results: z.array(monitorUsageByUserSchema),
  })
  .describe('Monitor Usage By User List')

export const monitorUsageByMonitorSchema = z
  .object({
    id: z.string(),
    name: z.string(),
    type: z.enum([
      'patent',
      'natural_language',
      'keyword',
      'filter_only',
      'office_action',
    ] as const),
    credits_used: z.number(),
  })
  .transform((data) => {
    const { credits_used, ...rest } = data
    return {
      ...rest,
      creditsUsed: credits_used,
    }
  })
  .describe('Monitor Usage By Monitor')

export type MonitorUsageByMonitorDetails = z.infer<
  typeof monitorUsageByMonitorSchema
>

export const monitorUsageByMonitorListSchema = z
  .object({
    pagination: paginationSchema,
    results: z.array(monitorUsageByMonitorSchema),
  })
  .describe('Monitor Usage By Monitor List')

export const monitorUsageSchema = z
  .object({
    data: z.object({
      credits_used: z.number(),
      total_credits: z.number(),
    }),
  })
  .transform(({ data }) => {
    const { credits_used, total_credits } = data
    return {
      creditsUsed: credits_used,
      totalCredits: total_credits,
      remainingCredits: Math.max(total_credits - credits_used, 0),
      percentage:
        total_credits > 0
          ? Math.min(credits_used / total_credits, 1).toLocaleString('en', {
              style: 'percent',
            })
          : '0%',
    }
  })
